import React from "react";
import suePhoto from "../../assets/SuePhoto.jpeg";
import "./FirstScreen.css";

export default function FirstScreen() {
  return (
    <div>
      <div className="containter-custom heading">
        <div>
          <h1 className="greeting-h1">
            Hello!👋🏻 I'm <span>Sue</span>
          </h1>
          <h2 className="greeting-h2">Front-End developer</h2>
        </div>
        <div className="image-hero ">
          <img src={suePhoto} alt="Logo" />
        </div>
      </div>
    </div>
  );
}
